import React from "react";
import "../style/component/_header.scss";
import { color } from "../constants";
// import { Switch, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "../hooks/useWindowSize";
import CustomDrawer from "./CustomDrawer";
export default function Header(props) {
  const navigate = useNavigate();

  const { width } = useWindowSize();

  const blogHandler = () => {
    navigate("/blog");
  };

  const homeHandler = () => {
    navigate("/");
  };

  const videoHandler = () => {
    navigate("/video");
  };
  return (
    <div className={props.theme ? "header" : "headerDark"}>
      <div className="innerHeader">
        <div className="left">
          <h4 onClick={homeHandler} style={{ cursor: "pointer" }}>
            Shravan<span style={{ color }}>Meena</span>
          </h4>
        </div>
        <div className="right">
          <div className="innerRight">
            {/* <h4 onClick={props.home}>Home</h4> */}
            {/* <h4 onClick={props.experties}>Skills</h4> */}
            {/* <h4 onClick={props.project}>projects</h4> */}
            <h4 onClick={homeHandler}>home</h4>
            <h4 onClick={blogHandler}>blogs</h4>
            <h4 onClick={videoHandler}>videos</h4>
            {/* <h4 onClick={props.contact}>contact</h4> */}
            {/* <h4 onClick={props.experience}>
              <Tag color="#f50">industry experience</Tag>
            </h4> */}

            {/* <h4>
              <Switch
                // style={{ marginRight: 20 }}
                checkedChildren="Light"
                unCheckedChildren="Dark"
                defaultChecked
                onClick={props.themeChange}
              />

              <Tag color="#f50">industry experience</Tag>
            </h4> */}
          </div>
        </div>
        <div className="end">
          {/* <span className="showLightMode">
            <Switch
              // style={{ marginRight: 20 }}
              checkedChildren="Light"
              unCheckedChildren="Dark"
              defaultChecked
              onClick={props.themeChange}
            />
          </span> */}
          {/* <a href={github} target='_blank'>
          <GithubOutlined />
        </a>
        <a href={linkedin} target='_blank'>
          <LinkedinOutlined />
        </a>
        <a href={medium} target='_blank'>
          <MediumOutlined />
        </a> */}

         {width < 900 ?  <CustomDrawer /> : <></>}
        </div>
      </div>
    </div>
  );
}
